import React from 'react'

import { string, arrayOf, shape } from 'prop-types'

import ImageMosaic from 'Pods/Shared/ImageMosaic/ImageMosaic'

import { MOCK_COLLECTION_DETAIL } from '../Mocks/collectionDetailData'

function CollectionDetailHero({ data = MOCK_COLLECTION_DETAIL }) {
  const { title, description, images } = data

  return (
    <section className="collection-detail-hero" aria-labelledby="collection-hero-title">
      <div className="collection-detail-hero__banner">
        <div className="collection-detail-hero__heading">
          <h1 id="collection-hero-title" className="collection-detail-hero__title">{title}</h1>
          <p className="collection-detail-hero__description">{description}</p>
        </div>
        <ImageMosaic images={images} />
      </div>
    </section>
  )
}

CollectionDetailHero.propTypes = {
  data: shape({
    title: string,
    description: string,
    images: arrayOf(shape({
      id: string.isRequired,
      url: string.isRequired,
      alt: string.isRequired,
    })),
  }),
}

export default CollectionDetailHero
